import React from 'react';
import { Row, Col, Card, Button, Spinner } from 'react-bootstrap';

interface PrintTestCardProps {
  isLoading: boolean;
  onPrintTestText: () => void;
}

export const PrintTestCard: React.FC<PrintTestCardProps> = ({
  isLoading,
  onPrintTestText,
}) => (
  <Row className="mb-4">
    <Col lg={8}>
      <Card>
        <Card.Header>
          <Card.Title className="mb-0">Testowanie drukowania</Card.Title>
        </Card.Header>
        <Card.Body>
          <p className="text-muted">
            Wydrukuj tekst testowy, aby sprawdzić połączenie z drukarką.
          </p>

          <div className="d-flex gap-2 flex-wrap">
            <Button
              variant="primary"
              onClick={onPrintTestText}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Drukowanie...
                </>
              ) : (
                'Wydrukuj tekst testowy'
              )}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Col>
  </Row>
);
